// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { chiliz as _chiliz } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the chiliz chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 88888
 * Chain Name: Chiliz Chain
 * Default Block Explorer: https://scan.chiliz.com
 * Default RPC URL: https://rpc.ankr.com/chiliz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { chiliz } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: chiliz,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const chiliz = createCommon({
	..._chiliz,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
